// Friendly customer-facing booking reference derived from a trip's
// `public_id` (UUID). Renters and hosts see the short 8-char uppercase
// version on their booking pages, support emails, etc., so the admin shell
// uses the same format wherever it shows a trip ID. The full UUID is still
// kept around (in tooltips / clipboard) for engineering use.
//
// Centralised here so admin and customer surfaces cannot drift out of sync.

export function formatBookingShortRef(publicId: string | null | undefined): string {
  if (publicId == null) return "";
  const str = String(publicId);
  if (!str) return "";
  return str.slice(0, 8).toUpperCase();
}
